import { ChakraProvider } from '@chakra-ui/react';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import '@fontsource/montserrat';

import App from './App';
import theme from './theme';
import { TelemedicinaProvider } from './context/TelemedicinaContext';

import ScrollToTop from './ScrollToTop';
import AppManutencao from 'components/AppManutencao';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <ChakraProvider theme={theme}>
      <ScrollToTop />
      <TelemedicinaProvider>
        <App />
      </TelemedicinaProvider>
    </ChakraProvider>
  </BrowserRouter>
);
